document.querySelectorAll(".footer-block--menu .footer-block__heading").forEach((ele) => {
    ele.addEventListener("click", () => {
        let nextElement = ele.nextElementSibling;

        // Close any previously opened elements and remove active class
        document.querySelectorAll(".footer-block--menu .footer-block__heading").forEach((el) => {
            if (el !== ele) {
                el.classList.remove("active");
                el.nextElementSibling.style.display = "none";
            }
        });

        // Toggle the clicked one
        if (nextElement) {
            let isOpen = nextElement.style.display === "block";
            nextElement.style.display = isOpen ? "none" : "block";

            // Toggle active class
            ele.classList.toggle("active", !isOpen);
        }
    });
});
